'use client'

const usePwaStatus = () => {
    const isPWA = typeof window !== 'undefined' ? window.matchMedia('(display-mode: standalone)').matches || (window.navigator as Navigator & { standalone?: boolean }).standalone === true : false;

    return {
        isPWA
    };
}

export default usePwaStatus;
